import React, { createContext, useContext } from 'react';

interface BlueconicMetaDataProps {
  variantId?: string;
}

const BlueconicContext = createContext<BlueconicMetaDataProps>({
  variantId: undefined,
});

export const BlueconicProvider = ({
  variantId,
  children,
}: {
  variantId: string;
  children: React.ReactNode;
}) => {
  const value = { variantId };
  return <BlueconicContext.Provider value={value}>{children}</BlueconicContext.Provider>;
};

export const useBlueconicContext = () => {
  const context = useContext(BlueconicContext);
  return context;
};
